import React from 'react';
import styled from 'styled-components';
import { mediaMax } from '../../Media Template/Media Template';
import { FlexContainer, Title } from '../../StyledComponents';

const StyledBannerDiv = styled.div.attrs({
  url: props => props.url,
  width: props => props.width,
  height: props => props.height
})`
  /* background: url('${props => props.url}'); */
  background: linear-gradient(
      to bottom,
      rgba(238, 238, 238, 0),
      rgba(139, 139, 139, 0) 24%,
      rgba(33, 33, 33, 0.94) 81%
    ),
    url(${props => props.url});
    background-attachment:fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: ${props => props.width};
  /* max-width: 1440px; */
  height: ${props => props.height};
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  /* padding: 0 1.5rem; */
  ${mediaMax.tablet`
    width: 100%;
  `}
`;

const createMarkup = content => {
  return { __html: content };
};

const NoClickBannerDivision = props => {
  const { title, subTitle, url } = props;

  const contentClickHandler = e => {
    const targetLink = e.target.closest('a');
    if (!targetLink) return;
    e.preventDefault();

    // console.log(targetLink.href);
    // console.log(targetLink.href.slice(22));

    // history.push(e.target.href.slice(21));
  };

  return (
    <StyledBannerDiv
      // width={width}
      height="520px"
      className="NoClickBannerDivision StyledBannerDiv flex justify-center items-center w-100"
      url={url}
    >
      <div style={{ paddingBottom: '1.75rem', maxWidth: '1040px' }}>
        {/* <FlexContainer className="Title-Subtitle-Rating"> */}
        <FlexContainer className="Title-And-Subtitle" direction="column">
          <Title
            fontFamily="Nunito"
            fontSize="2.5rem"
            fontWeight="bold"
            color="#fff"
            lineheight="1.17"
            letterSpacing="0.8px"
          >
            {title}
          </Title>
          {subTitle ? (
            <Title
              className="SubTitle"
              fontFamily="Montserrat"
              fontSize="1.25rem"
              fontstyle="italic"
              letterSpacing="0.3px"
              color="#fff"
              onClick={contentClickHandler}
              dangerouslySetInnerHTML={createMarkup(subTitle)}
            />
          ) : null}
        </FlexContainer>
        {/* </FlexContainer> */}
      </div>
    </StyledBannerDiv>
  );
};

export default NoClickBannerDivision;
